import React, { useMemo } from "react";
import { createCellEditor } from "../../EditableCellGrid";

function HeavyCellWrapper({
    editorType = "text",
    ...renderEditCellProps
}) {
    const renderEditor = useMemo(() => createCellEditor(editorType), [editorType]);

    if (!renderEditor) return null;

    return (
        <div className="grid-core-heavy-cell-wrapper">
            {renderEditor(renderEditCellProps)}
        </div>
    );
}

function getRenderedCellValue(props) {
    const columnKey = props.column?.key;
    return columnKey ? props.row?.[columnKey] : undefined;
}

function areHeavyCellWrapperPropsEqual(previous, next) {
    return (
        previous.editorType === next.editorType &&
        previous.rowIdx === next.rowIdx &&
        previous.row === next.row &&
        previous.column?.key === next.column?.key &&
        previous.column?.idx === next.column?.idx &&
        previous.column?.editorOptions === next.column?.editorOptions &&
        previous.column?.options === next.column?.options &&
        previous.column?.placeholder === next.column?.placeholder &&
        previous.column?.normalize === next.column?.normalize &&
        Object.is(getRenderedCellValue(previous), getRenderedCellValue(next)) &&
        previous.onRowChange === next.onRowChange &&
        previous.onClose === next.onClose
    );
}

export default React.memo(HeavyCellWrapper, areHeavyCellWrapperPropsEqual);
